// Step 05/09 — Association Transfers
// Wraps AssociationsPanel in a proper wizard step with header, footer nav,
// and a skip option. canContinue = all selected associations confirmed/signed.

import React from "react";
import { AssociationsPanel, ASSOC_OPTIONS } from "./associations.jsx";
import { FooterNav, StepHeader } from "./steps_early.jsx";

const { useState: aS } = React;

function StepAssociations({ onNext, onBack, associations, setAssociations, agent, updateTracker , eyebrow}) {
  const [skipping, setSkipping] = aS(false);

  const assocSel    = associations?.assoc || [];
  const formStatus  = associations?.formStatus || {};
  const selectedCnt = assocSel.length;
  const confirmedCnt = assocSel.filter(k => {
    const st = formStatus[`assoc:${k}`];
    if (st === "confirmed" || st === "signed") return true;
    // For online/email types, opening the link is the required action
    const meta = ASSOC_OPTIONS.find(a => a.k === k);
    if (meta?.formType !== "pdf" && st === "opened") return true;
    return false;
  }).length;
  const allDone = selectedCnt > 0 && confirmedCnt >= selectedCnt;

  async function handleContinue() {
    try { await updateTracker?.({ associationSubmitted: true }); } catch { /* non-blocking */ }
    onNext();
  }

  async function handleSkip() {
    setSkipping(true);
    try { await updateTracker?.({ associationSubmitted: false }); } catch { /* non-blocking */ }
    finally { setSkipping(false); }
    onNext();
  }

  return (
    <div style={{maxWidth: 1100}}>
      <StepHeader eyebrow={eyebrow || "Step 05 / 09"} title="Transfer your REALTOR membership."
        subtitle="Submit a member change form to each association you belong to. PDF forms can be signed here — online portals open with your details ready to paste."/>

      <AssociationsPanel
        associations={associations}
        setAssociations={setAssociations}
        agent={agent}
      />

      <div style={{height: 32}}/>

      <FooterNav
        onBack={onBack}
        onNext={allDone ? handleContinue : undefined}
        nextDisabled={!allDone}
        nextLabel={
          allDone          ? "Continue to Listing Transfers"
          : selectedCnt === 0 ? "Select at least one association"
          : `${confirmedCnt} of ${selectedCnt} submitted — complete all to continue`
        }
      />

      {!allDone && (
        <div style={{textAlign: "right", marginTop: 12}}>
          <span
            style={{fontSize: 12, color: "var(--ep-fg-muted)", cursor: skipping ? "default" : "pointer"}}
            onClick={skipping ? undefined : handleSkip}>
            {skipping ? "Saving…" : "Skip for now — I'll handle this later"}
          </span>
        </div>
      )}
    </div>
  );
}

export { StepAssociations };
